import firebase from 'firebase/app';
import 'firebase/messaging';

let cachedTokenPromise = null;

export const initializeFirebase = () => {
  firebase.initializeApp({
    apiKey: "AIzaSyDtgL6eeA8KxN28JvfnN69otJ4PAz1Gzkg",
    authDomain: "trackervanillaplusbe.firebaseapp.com",
    projectId: "trackervanillaplusbe",
    storageBucket: "trackervanillaplusbe.firebasestorage.app",
    messagingSenderId: "456613346491",
    appId: "1:456613346491:web:5292490873c018666b3d9e"
  });

  // Pre-warm: if permission already granted, get token in background
  if (Notification.permission === 'granted' && 'serviceWorker' in navigator && !window.__nativePushToken) {
    cachedTokenPromise = navigator.serviceWorker.ready.then(swReg =>
      firebase.messaging().getToken({
        serviceWorkerRegistration: swReg
      })
    ).catch(() => null);
  }
}

export const askForPermissionToReceiveNotifications = async () => {
    // If running inside the native iOS app, use the native push token
    // injected by AppDelegate instead of requesting a web push token.
    if (window.__nativePushToken) {
        console.info("[Firebase] Using native iOS push token");
        localStorage.setItem("fcm_token", window.__nativePushToken);
        return { status: "SUCCESS", token: window.__nativePushToken };
    }
    if (window.webkit?.messageHandlers?.nativePush) {
        console.info("[Firebase] Native iOS app detected, waiting for token...");
        const token = await new Promise((resolve) => {
            let attempts = 0;
            const check = setInterval(() => {
                if (window.__nativePushToken) {
                    clearInterval(check);
                    resolve(window.__nativePushToken);
                } else if (++attempts >= 50) {
                    clearInterval(check);
                    resolve(localStorage.getItem("fcm_token") || null);
                }
            }, 100);
        });
        if (token) {
            console.info("[Firebase] Got native iOS push token after waiting");
            localStorage.setItem("fcm_token", token);
            return { status: "SUCCESS", token: token };
        }
        console.warn("[Firebase] Native iOS app but no token available");
    }
  try {
    const messaging = firebase.messaging();

    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      return ({ status: "FAIL", error: "Notification permission denied" });
    }
    let token;
    if (cachedTokenPromise) {
      token = await cachedTokenPromise;
    }
    if (!token) {
      const swReg = await navigator.serviceWorker.ready;
      token = await messaging.getToken({
        serviceWorkerRegistration: swReg
      });
    }
    return ({
      status: "SUCCESS",
      token: token
    });
  } catch (error) {
    return ({
      status: "FAIL",
      error: error
    });
  }
}
